<nav id="navbar" class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top mb-5" [options]="options"
  Ngxheadroom [ngClass]="{ 'd-flex justify-content-between' : isMobile | async }">
  <button (click)="isCollapsed = !isCollapsed" class="navbar-toggler" type="button" data-toggle="collapse"
    data-target="#navbar-main" aria-controls="navbar-main" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <img src="https://hsccdn.blob.core.windows.net/devcdn/unthealthlogo1.png" class="nav-img my-0 mr-md-auto navbar-brand" alt="UNT Health Fort Worth Logo" routerLink="/" />
  <div class="collapse navbar-collapse w-100" id="navbar-main" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
      <li class="nav-item mr-1">
        <a class="nav-link" href="/" [ngClass]="{ 'pl-3' : isMobile | async }">Home</a>
      </li>
      <li class="nav-item mr-1">
        <a class="nav-link" href="/directory" [ngClass]="{ 'pl-3' : isMobile | async }">Profile Search</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://unthsc.edu" target="_blank" [ngClass]="{ 'pl-3' : isMobile | async }">UNT Health Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="https://experts.unthsc.edu" target="_blank" [ngClass]="{ 'pl-3' : isMobile | async }">UNT Health Research Profiles</a>
      </li>
    </ul>
  </div>
</nav>